import { render, staticRenderFns } from "./CheckBoxItem.vue?vue&type=template&id=bfd03fc6&scoped=true&"
import script from "./CheckBoxItem.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxItem.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxItem.vue?vue&type=style&index=0&id=bfd03fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd03fc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VInput,VRow,VTextField})
